<ds-dialog skyTranslationGuard="skypro-reset-dialog">
  <ng-container dsDialogHeader>
    {{ 'skyproLibsBlocksPythonResetDialog.resetQuestionMessage' | transloco }}
  </ng-container>
  <ng-container dsDialogBody>
    {{ 'skyproLibsBlocksPythonResetDialog.resetQuestionDescription' | transloco }}
  </ng-container>
  <div class="buttons" dsDialogFooter>
    <ds-button class="button" size="m" type="primary-blue" (click)="confirm()">
      {{ 'skyproLibsBlocksPythonResetDialog.resetConfirmMessage' | transloco }}
    </ds-button>
    <ds-button class="button" size="m" type="secondary-blue" (click)="cancel()">
      {{ 'skyproLibsBlocksPythonResetDialog.resetAbortMessage' | transloco }}
    </ds-button>
  </div>
</ds-dialog>
